import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import Popover from '@mui/material/Popover';
import { makeStyles } from '@mui/styles';

import RequestPopupContent from '../../StopMarkerRequestPopup/RequestPopupContent';
import palette from '../../styles/palette';
import { View } from '../../Base';
import MarkerWithClickHandler from '../../StopsMapLayer/MarkerWithClickHandler';
import arrowPopup from '../../../assets/arrowPopup.svg';

const useStyles = makeStyles({
  popup: {
    '& .MuiPopover-paper': {
      color: palette.typography.white.solid,
      borderRadius: '8px',
      paddingLeft: '20px',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      backgroundColor: 'transparent',
      boxShadow: 'none',

      '&:before': {
        width: '18px',
        height: '28px',
        backgroundImage: `url(${arrowPopup})`,
        content: "''",
        position: 'absolute',
        left: '2px',
        top: '50%',
        transform: 'translate(0%, -50%)',
      },
    },
  },
});

const StopMarkerWithPopover = ({ stop }) => {
  const itemRef = useRef();
  const styles = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!stop.properties.stop.requests?.length) {
      setOpen(false);
    }
  }, [stop]);

  const hasRequest = useMemo(
    () => stop.properties.stop.requests?.length,
    [stop]
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <>
      <MarkerWithClickHandler
        feature={stop}
        parentComponent={View}
        showRequestPopup={handleOpen}
        withAnchor={false}
        itemRef={itemRef}
      />
      <Popover
        anchorEl={itemRef.current}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        marginThreshold={null}
        className={styles.popup}
        open={open}
        onClose={handleClose}
      >
        {hasRequest && (
          <RequestPopupContent
            onClose={handleClose}
            stop={stop.properties.stop}
          />
        )}
      </Popover>
    </>
  );
};

export default memo(StopMarkerWithPopover);
